// EN translate file
import commonEn from './locales/en/common.json';
import clubAppEn from './locales/en/clubApp.json';

// JP translate file
import commonJp from './locales/jp/common.json';
import clubAppJp from './locales/jp/clubApp.json';

const resources = {
  en: {
    common: commonEn,
    clubApp: clubAppEn,
  },
  jp: {
    common: commonJp,
    clubApp: clubAppJp,
  },
};

export default resources;
